import type { SVGProps } from 'react';

export const ChevronRebrandIcon: React.FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none" {...props}>
    <path d="M1.175 0.912598L5 4.72926L8.825 0.912598L10 2.0876L5 7.0876L0 2.0876L1.175 0.912598Z" fill="#191919" />
  </svg>
);
